import Source from './models/Source.js'
import Layer from './models/Layer.js';
import DataManager from './DataManager.js'
import mapBoxMatches from './mapboxMatches.js'

/* eslint-disable no-console*/
export default class OkanMap {
    constructor() {

        this.server = "http://maps.okenite.xyz";

        this.time = 0;
        this.map = null;
        this.uniquesIDs = [];
        this.uniquesIDsNumber = [];
        this.mapBoxMatches = mapBoxMatches;

        this.mapStyle = 'https://maps.okan3d.com/images/style.json'

        this.dataManager = new DataManager(this);

        this.sources = [];
        this.layers = [];

        this.saveName = 'My map';

        // -------- POPUP Window 
        this.showPopup = false;
        this.popupTitle = 'Titre du popup'
        this.popupHTML = 'sjdha dfh sdk sdfhsd fhsf sdfhsdkfsd fsdf sdfbsd bsd fbsdf sdkf sdk<p>sjdha dfh sdk sd</p><p>sjdha dfh sdk sd</p><p>sjdha dfh sdk sd</p><p>sjdha dfh sdk sd</p>'
        // -------- COLOR 

        this.colorPicker = null;
        this.showColorPicker = false;
        this.currentColor = {r:255,g:0,b:0,a:1}
        this.usedColors = ['#AE8CA3', '#817F82', '#A2ABB5', '#95D9DA']
        this.colorBlueprintMode = false;
        this.colorLayersParamsApply = ['appearance', 'background', 'color']
        this.colorLayerApply = null;
        this.colorNodeId = 0;

        // -------- SOURCE SELECTION

        this.tmpSource = null;

        this.datasetView = false;

        this.SourcesWindow = {
            visible : false,
            datasetView : false
        }

        

        this.sourceProviders = [];

        // -------- END SOURCE SELECTION

        //GRAPH
        this.graphComponent = null;
        this.graphOpen = false;
        this.graphSave = null;
        this.graph_getFields = ['allowedPersons', 'latitude', 'longitude', 'Address', 'Name', 'DateConstruction'];
        this.graph_finalNodeName = 'Radius';
        this.graph_layer = {};
        this.graphLayerId = null;
        this.graph_layer_params = ['radius']

       
        this.init()

        this.dataPointToFill = null;
        this.dataPointToFill_radius = 100;
        this.dataPointToFill_edges = 10;
        

/*
        this.animate = () => {
            requestAnimationFrame( this.animate );
            this.time += 0.1

            

            if(this.time > 1000000000000000)
                this.time = 0

                
                if(this.map != null) {

                    //Adds 'tick' to source data
                    
                    this.layers.forEach((l) =>{

                        if(l.exposeTick) {
                            var newdata = this.sources[l.sourceIndex].data;
                            newdata.features.forEach((f) => {
                                f.properties.tick = this.time;
                            })
                            this.map.getSource(l.mapSourceName).setData(newdata);
                        }
                        
                    })
    
                }
                
               

            //console.log(extrude_cool)
        }
        this.animate();
*/

    }

    init() {

        console.log('mapBoxMatches', mapBoxMatches);
        this.sourceProviders = this.dataManager.getProviders();

        
    }

    bringToTop(layer) {
        var layers = this.map.getStyle().layers;

        console.log(layers[layers.length - 1].id)
        
        this.map.moveLayer(layer.mapLayerName, layers[layers.length - 1].id)

        if(layer.mapClusterLayerName != '')
            this.map.moveLayer(layer.mapClusterLayerName, layers[layers.length - 1].id)
        if(layer.mapClusterTextLayerName != '')
            this.map.moveLayer(layer.mapClusterTextLayerName, layers[layers.length - 1].id)
        if(layer.mapContourLayerName != '')
            this.map.moveLayer(layer.mapContourLayerName, layers[layers.length - 1].id)


    }

    setLayerFilters(layer){

        //var filters = []
        var filterData = '';
        var countFilterData = 0;
        this.getSourceFromlayer(layer).properties.forEach( (prop) => {
            if(prop.filter.enabled) {
                if(prop.type == 'float') {
                    /*
                    var filterMin = ['>=', ['to-number',['get',prop.name]], ['to-number',prop.filter.min ]];
                    var filterMax = ['<=', ['to-number',['get',prop.name]], ['to-number',prop.filter.max ]];
                    var filterNew = ['all', filterMin, filterMax];

                    filters.push(filterNew);*/

                    if(countFilterData > 0)
                        filterData += ' && ';

                    filterData += '(f.properties["' + prop.name + '"] >= ' + prop.filter.min + ' && ' + 'f.properties["' + prop.name + '"] <= ' + prop.filter.max + ')';
                    
                }
                else if(prop.type == 'date') {
                    // blocked
                    if(countFilterData > 0)
                        filterData += ' && ';

                    filterData += '(this.toDateTime(f.properties["' + prop.name + '"]) >= ' + prop.filter.min + ' && ' + 'this.toDateTime(f.properties["' + prop.name + '"]) <= ' + prop.filter.max + ')';
                }

                countFilterData++;
            }
        })

        /*
        var finalFilter = ['all', ["!", ["has", "point_count"]]];
        var finalFilterCluster = ['all', ["has", "point_count"]];

        filters.forEach( (filter) => {
            finalFilter.push(filter);
            finalFilterCluster.push(filter)
        }) 
        */

        /*


        this.map.setFilter(layer.mapLayerName, finalFilter);

        if(layer.mapClusterLayerName != '')
            this.map.setFilter(layer.mapClusterLayerName, finalFilterCluster);
        if(layer.mapClusterTextLayerName != '')
            this.map.setFilter(layer.mapClusterTextLayerName, finalFilterCluster);
        if(layer.mapContourLayerName != '')
            this.map.setFilter(layer.mapContourLayerName, finalFilter);
            

        console.log('finalFilterCluster', finalFilterCluster)
        //console.log('finalFilter', finalFilter)
        */
        //console.log(filterData);
        

        if(filterData > '') {

            //console.log('f => ' + filterData)

            if(filterData.startsWith(' && '))
                filterData = filterData.substring(4);

            if(layer.name == 'Events')
                console.log(filterData);

            var filteredGeoJSON = {
                type: "FeatureCollection",
                features: this.getSourceFromlayer(layer).data.features.filter(eval('f => ' + filterData))
            }

            this.map.getSource(layer.mapSourceName).setData(filteredGeoJSON)
        }
        else {
            this.map.getSource(layer.mapSourceName).setData(this.getSourceFromlayer(layer).data)
        }
        
        

    }

    toDateTime(datestr){
        return new Date(datestr).getTime()
    }
    

    getSourceFromlayer(layer){
        return this.sources[layer.sourceIndex];
    }

    getSourceProperties(source){
        var properties = source.data.features[0].properties;
        var output = []
        for(var attr in properties) {
            if(attr != 'tick' && attr != 'zoom') {
                var type = 'string';
                var value = properties[attr];
                if(value == null || value == 'null')
                    type = 'string'
                else if (!isNaN(value))
                    type = 'float'
                else if(this.checkDateValid(value))
                    type = 'date'
                
                var minmax = this.getMinMaxForProperty(source, attr, type)

                var errordate = false;

                if(type=='date' && (Number(new Date(minmax.max).getFullYear()) > 5000 || Number(new Date(minmax.min).getFullYear()) < -5000) ) {
                    //console.log('Wrongfully parsed date')
                    //console.log(attr)
                    //console.log(source)
                    type = 'string';
                    //minmax = this.getMinMaxForProperty(source, attr, type)
                    //console.log(properties[attr])
                    //errordate = true;
                }

                if(minmax.min == minmax.max)
                    type = 'invalid';

                //if(type =='float' || type == 'date') {
                    output.push(
                        {
                            name : attr,
                            min: minmax.min,
                            max: minmax.max,
                            type: type,
                            filter: { 
                                enabled: false, 
                                min : minmax.min,
                                max: minmax.max
                            }
                        }
                    )
                //}

                if(errordate)
                    console.log(output)
                
            }
        }
        return output;
    }

    getMinMaxForProperty(source, attribute, type){
        var min = null;
        var max = null;

        if(type == 'float' || type == 'date') {
            source.data.features.forEach((feature) => {

                try {
                    var value = feature.properties[attribute];
    
                    if(type == 'float')
                        value = Number(value);
                    else if(type == 'date')
                        value = new Date(value).getTime();

                    if(min == null || value <= min)
                        min = value;
                    if(max == null || value >= max)
                        max = value;
                }
                catch(e){
                    console.log(e);
                }
                
            })
        }
        

        return { min: min, max: max};
    }

    setVisibility(layer) {
        var visibilityStr = 'visible';
        if(!layer.visible) {
            visibilityStr = 'none';
        }
        this.map.setLayoutProperty(layer.mapLayerName, 'visibility', visibilityStr);
        try {
            if(layer.mapClusterLayerName.trim() != '')
                this.map.setLayoutProperty(layer.mapClusterLayerName, 'visibility', visibilityStr);
            if(layer.mapClusterTextLayerName.trim() != '')
                this.map.setLayoutProperty(layer.mapClusterTextLayerName, 'visibility', visibilityStr);
            if(layer.mapContourLayerName.trim() != '')
                this.map.setLayoutProperty(layer.mapContourLayerName, 'visibility', visibilityStr);
        }
        catch(e) {
            console.log(e)
        }
    }
    sortLayers(){

        var layer_prec_name = '';
        for(var i = this.layers.length - 1; i >= 0; i--) {
            if(layer_prec_name != null) {
                this.map.moveLayer(this.layers[i].mapLayerName, 'layer_prec_name')
            }
            else {
                layer_prec_name = this.layers[i].mapLayerName
            }
            
            
        }

        this.layers.forEach((layer) => {

        })
        //this.map.moveLayer(layer.mapLayerName, 'country_label')
    }

    clickFeature(layer, feature){
        this.popupTitle = this.applyFeaturesToHtml(layer.popupTitle, feature);
        this.popupHTML = this.applyFeaturesToHtml(layer.popupHTML, feature);
        this.showPopup = true;
    }

    applyFeaturesToHtml(text, feature) {
        var rxp = /{([^}]+)}/g;
        // {name} dfdhfksdn s fd {size}

        var found = []
        var curMatch;

        while( curMatch = rxp.exec( text ) ) {
            found.push( curMatch[1] );
        }

        var newText = text;

        found.forEach((f) => {
            var computed_expression = feature.properties[f];

            if(this.checkDateValid(computed_expression)) {
                computed_expression = this.dateToString(new Date(computed_expression));
            }

            newText = newText.replace( '{' + f + '}',  computed_expression);


        })

        return newText;
    }

    dateToString(d){

        var minutes = d.getMinutes().toString().length == 1 ? '0'+d.getMinutes() : d.getMinutes();
        var hours = d.getHours().toString().length == 1 ? '0'+d.getHours() : d.getHours();
        var days = d.getDate().toString().length == 1 ? '0'+ d.getDate() : d.getDate();
        var month = d.getMonth() + 1;
        var months = month.toString().length == 1 ? '0'+ month : month;
        var hoursminutes = hours+':'+minutes;

        if(hours == '00' && minutes == '00')
           hoursminutes = ''

        return days + '/' + months +'/'+ d.getFullYear() +' '+hoursminutes;
    }

    checkDateValid(str) {

        if(isNaN(str)) {
            var date0 = new Date(str)
		    return (Boolean(+date0))
        }
        else {
            return false;
        }
        
    }

    isInt(n){
        return Number(n) === n && n % 1 === 0;
    }
    
    isFloat(n){
        return Number(n) === n && n % 1 !== 0;
    }

    loadMap(mapFile){
        var reader = new FileReader();

        reader.readAsText(mapFile);
        reader.addEventListener('load',(event) => {

            var data = event.target.result;
            this.loadMapData(data);


        });
    }

    loadMapData(data, json = false) {
        var loadMapParam = data
        if(!json)
            loadMapParam = JSON.parse(data);

        this.deleteAll();

        this.sources = loadMapParam.sources;
        this.layers = loadMapParam.layers;
        this.drawAll();
    }

    saveMap(){
        console.log('saving...')

        /*
        this.downloadObjectAsJson({
            sources: this.sources,
            layers: this.layers,
        },
        this.saveName.replace(/[^a-z0-9]/gi, '_').toLowerCase())
        */

        var saveName = this.saveName.replace(/[^a-z0-9]/gi, '_').toLowerCase();
        var saveContent = JSON.stringify({ sources: this.sources, layers: this.layers });
/*
        var xmlhttp = new XMLHttpRequest();
        xmlhttp.onreadystatechange = function() {
            if (this.readyState == 4 && this.status == 200) {
                console.log(this.responseText)
            }
        };
        xmlhttp.open("POST", this.server+"/save.php", true);
        xmlhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xmlhttp.send('name='+encodeURIComponent(saveName) + '&content='+encodeURIComponent('bite'));

*/
        /*
        ****************************************************
        */

       var request = new XMLHttpRequest();
       request.open('POST', this.server+"/save.php", true);
       request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
       request.responseType = 'blob';
   
       request.onload = function() {
         // Only handle status code 200
         if(request.status === 200) {
           // Try to find out the filename from the content disposition `filename` value
           var disposition = request.getResponseHeader('content-disposition');
           var matches = /"([^"]*)"/.exec(disposition);
           var filename = (matches != null && matches[1] ? matches[1] : 'map.json');
   
           // The actual download
           var blob = new Blob([request.response], { type: 'application/json' });
           var link = document.createElement('a');
           link.href = window.URL.createObjectURL(blob);
           link.download = filename;
   
           document.body.appendChild(link);
   
           link.click();
   
           document.body.removeChild(link);
         }
         
         // some error handling should be done here...
       };
   
       //request.send('content=' + content);
       request.send('name='+encodeURIComponent(saveName) + '&map='+encodeURIComponent(saveContent));

        /*
        ****************************************************
        */

    }

    deleteAll(){
        
        var sclength = this.sources.length;
        for(var i = sclength - 1; i >= 0; i--) {
            this.deleteSource(i, null);
        }
    }

    drawAll(){
        this.layers.forEach( (layer) => {
            layer.expanded = false;
            layer.mapLayerName = ''
            layer.mapClusterLayerName = ''
            layer.mapClusterTextLayerName = ''
            layer.mapContourLayerName = ''
            layer.mapSourceName = ''
            this.drawLayer(layer);
        } )
    }

    downloadObjectAsJson(exportObj, exportName){
        //console.log(JSON.stringify(exportObj));
        //console.log(exportObj);
        var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(exportObj));
        //console.log(dataStr);
        var downloadAnchorNode = document.createElement('a');
        downloadAnchorNode.setAttribute("href",     dataStr);
        downloadAnchorNode.setAttribute("download", exportName + ".json");
        document.body.appendChild(downloadAnchorNode); // required for firefox
        downloadAnchorNode.click();
        downloadAnchorNode.remove();
    }

    getTime() {
        return this.time;
    }

    // return a unique ID 
    uniqueId(length = 10) {
        var idUniq = Math.round((Math.pow(36, length + 1) - Math.random() * Math.pow(36, length))).toString(36).slice(1);

        while(this.uniquesIDs.includes(idUniq)) {
            idUniq = Math.round((Math.pow(36, length + 1) - Math.random() * Math.pow(36, length))).toString(36).slice(1);
        }

        this.uniquesIDs.push(idUniq);

        return idUniq;
    }

    uniqueIdNumber() {
        var maxId = Math.max.apply(this.uniquesIDsNumber);
        maxId += 1;

        this.uniquesIDsNumber.push(maxId)

        return maxId;

    }

    getLayerSource(layer) {
        return this.sources[layer.sourceIndex];
    }

    getLayerParams(layer) {
        return layer.layerTypeParams[layer.typeIndex].params;
    }

    deleteSource(indexSource, source = null){
        
        console.log('deleting source...', indexSource)
        console.log(this.layers)

        // Remove layers using this source
        var layersToRemove = this.layers.filter(l => l.sourceIndex == indexSource);
        this.layers.filter(l => l.sourceIndex == indexSource).forEach(ly => {
            this.deleteLayer(ly)
        });

        // Remove the source
        this.sources.splice(indexSource, 1);

        // Update sourceIndex for other layers
        var layersToUpdate = this.layers.filter(l => l.sourceIndex > indexSource);
        layersToUpdate.forEach(ly => {
            this.layers.find(l => l.id == ly.id).sourceIndex -= 1; 
        });

        
    }

    deleteLayer(layer) {
        console.log('deleting layer...', layer )
        try {
            if(layer.mapLayerName != '')
                this.map.removeLayer(layer.mapLayerName)
            if(layer.mapClusterLayerName != '')
                this.map.removeLayer(layer.mapClusterLayerName)
            if(layer.mapClusterTextLayerName != '')
                this.map.removeLayer(layer.mapClusterTextLayerName)
            if(layer.mapContourLayerName != '')
                this.map.removeLayer(layer.mapContourLayerName)
            
            if(layer.mapSourceName != '')
                this.map.removeSource(layer.mapSourceName)

            layer.mapLayerName = ''
            layer.mapClusterLayerName = ''
            layer.mapClusterTextLayerName = ''
            layer.mapContourLayerName = ''
            layer.mapSourceName = ''
        }
        catch(e) {
            console.log(e);
        }

        var indexLayer = this.layers.findIndex(l => l.id == layer.id)
        this.layers.splice(indexLayer, 1);

    }

    drawLayer(layer) {

        //console.log(this.getLayerSource(layer))
        //console.log('drawing layer', layer)
        //console.log(this.map)

        // *********************************************************
        // Removing existing Mapbox source and layers for this layer
        // ---------------------------------------------------------

        try {
            if(layer.mapLayerName != '')
                this.map.removeLayer(layer.mapLayerName)
            if(layer.mapClusterLayerName != '')
                this.map.removeLayer(layer.mapClusterLayerName)
            if(layer.mapClusterTextLayerName != '')
                this.map.removeLayer(layer.mapClusterTextLayerName)
            if(layer.mapContourLayerName != '')
                this.map.removeLayer(layer.mapContourLayerName)
            
            if(layer.mapSourceName != '')
                this.map.removeSource(layer.mapSourceName)

            layer.mapLayerName = ''
            layer.mapClusterLayerName = ''
            layer.mapClusterTextLayerName = ''
            layer.mapContourLayerName = ''
            layer.mapSourceName = ''
        }
        catch(e) {
            console.log(e);
        }

        
        // *********************************************************
        //          Create mapBox source for layer
        // ---------------------------------------------------------
        layer.mapSourceName = this.uniqueId();
        
        var params = this.getLayerParams(layer);

        var attributes = {}
        for (var attr in this.getLayerSource(layer).data.features[0].properties) {


            var clusterPropSum = ["+", ["to-number", ["get", attr] ] ]

            var clusterPropAv =  ['/', clusterPropSum,  ["get", "point_count"] ];

            attributes['sum_' + attr] = clusterPropSum;
            attributes['av_' + attr] = clusterPropAv;



        }

        //console.log('cluster attributes', attributes)

        this.map.addSource(layer.mapSourceName, {
            type: "geojson",
            data : this.getLayerSource(layer).data,
            cluster : params.clustered != undefined ? params.clustered : false ,
            clusterRadius: params.clusterRadius != undefined ? params.clusterRadius : 0, 
            clusterMaxZoom : params.clusterMaxZoom != undefined ? params.clusterMaxZoom : 0,
            generateId: true,
            lineMetrics: true,
            clusterProperties: {

            }
        })
        

        // *********************************************************
        //          Create mapBox layers
        // ---------------------------------------------------------

        var aboveLayer = 'country_label'
        if(params.underBuildings)
            aboveLayer = 'building-3d'


        layer.mapLayerName = this.uniqueId();

        var mapboxLayer = this.getMapboxMainLayerParams(layer);

        this.map.addLayer({
            id: layer.mapLayerName,
            type: mapboxLayer.type,
            source: layer.mapSourceName,
            paint: mapboxLayer.paint,
            filter: ["!", ["has", "point_count"]],
        },
        aboveLayer); //'country_label' for above, 'building-3d' for under buildings


        if(layer.typeIndex == 0 && params.clustered) { // If clustered point layer, create two other Mapbox Layer for cluster and text
            var clustersLayers = this.getMapboxClusteredLayerParams(layer);
            layer.mapClusterLayerName = this.uniqueId();

            // mapboxLayer cluster circle
            this.map.addLayer({
                id: layer.mapClusterLayerName,
                type: "circle",
                source: layer.mapSourceName,
                filter: ["has", "point_count"],
                paint : clustersLayers[0].paint
            },
            aboveLayer);

            layer.mapClusterTextLayerName = this.uniqueId();

            // mapboxLayer cluster text
            this.map.addLayer({
                id: layer.mapClusterTextLayerName,
                type: "symbol",
                source: layer.mapSourceName,
                filter: ["has", "point_count"],
                layout : clustersLayers[1].layout,
                paint : clustersLayers[1].paint
            });
        }
        if (layer.typeIndex == 1){ // If zone layer, create additional contour layer
            var contourLayer= this.getMapboxContourLayerParams(layer);

            layer.mapContourLayerName = this.uniqueId();

            this.map.addLayer({
                id: layer.mapContourLayerName,
                type: "line",
                source: layer.mapSourceName,
                filter: ["!", ["has", "point_count"]],
                paint : contourLayer.paint
            },
            aboveLayer);

            this.map.moveLayer(layer.mapLayerName, 'country_label')

        }

        this.setVisibility(layer)


        this.map.on('mouseenter', layer.mapLayerName, () => {
            this.map.getCanvas().style.cursor = 'pointer';
        });

        this.map.on('mouseleave', layer.mapLayerName, () => {
            this.map.getCanvas().style.cursor = '';
        });

        this.map.on('click', layer.mapLayerName, (e) => {
            this.clickFeature(layer, e.features[0]);
        });

        setTimeout(() => { 
            //this.setLayerFilters(layer);
        }, 1000);
        
        

    }

    
    getColorStr(color) {

        if(color.r != undefined) {
            return'rgba(' 
            + color.r + ', ' 
            + color.g + ', ' 
            + color.b + ', '
            + color.a + ')'
        }
        else {
            return color;
        }
    }

    // return the contour layer params for zones
    getMapboxContourLayerParams(layer) {
        var params = this.getLayerParams(layer);

        var contourLayerParams = { paint: null};

        if(layer.typeIndex == 1){
            contourLayerParams = {
                paint : {
                    "line-gradient": this.getParam(this.getColorStr(params.appearance.stroke.color)),
                    "line-opacity": this.getParam(params.appearance.stroke.opacity),
                    "line-width": this.getParam(params.appearance.stroke.width),
                    "line-gap-width": this.getParam(params.appearance.stroke.gapWidth),
                    "line-blur": this.getParam(params.appearance.stroke.blur),
                }
            }
        }

        return contourLayerParams;
    }

    // return the two mapbox clusters params
    getMapboxClusteredLayerParams(layer) {

        var params = this.getLayerParams(layer);

        var circle_pitch_alignment = 'viewport';
        if(params.mapAligned)
            circle_pitch_alignment = 'map';

        var mapboxLayerCluster_circle = {
            paint: {
                "circle-color": this.getParam(this.getColorStr(params.appearance.clustered.background.color)),
                "circle-opacity": this.getParam(params.appearance.clustered.background.opacity),
                "circle-radius": this.getParam(params.clusterCircleRadius),
                "circle-stroke-width" : this.getParam(params.appearance.clustered.stroke.width),
                "circle-stroke-color" : this.getParam(this.getColorStr(params.appearance.clustered.stroke.color)),
                "circle-stroke-opacity" : this.getParam(params.appearance.clustered.stroke.opacity),
                "circle-pitch-alignment" : circle_pitch_alignment,
            }
        };
        
        var mapboxLayerCluster_text = {
            layout: {
                "text-field": "{point_count_abbreviated}",
                "text-font": ["Klokantech Noto Sans Bold"],
                "text-size": params.appearance.clustered.text.size
            },
            paint : {
                "text-color": this.getParam(this.getColorStr(params.appearance.clustered.text.color)),
                "text-opacity": this.getParam(params.appearance.clustered.text.opacity)
            }
        };

        return [mapboxLayerCluster_circle, mapboxLayerCluster_text];
    }

    // get mapbox layer parameters from layer object
    getMapboxMainLayerParams(layer) {

        var params = this.getLayerParams(layer);
        var mapboxLayer = null;

        
        if(layer.typeIndex == 0) { // POINTS

            var circle_pitch_alignment = 'viewport';
            if(params.mapAligned)
                circle_pitch_alignment = 'map';

            mapboxLayer = {
                type: 'circle',
                
                paint: {
                    "circle-color": this.getParam(this.getColorStr(params.appearance.background.color)),
                    "circle-opacity": this.getParam(params.appearance.background.opacity),
                    "circle-radius": this.getParam(params.radius),
                    "circle-stroke-width": this.getParam(params.appearance.stroke.width),
                    "circle-stroke-color": this.getParam(this.getColorStr(params.appearance.stroke.color)),
                    "circle-stroke-opacity" : this.getParam(params.appearance.stroke.opacity),
                    "circle-pitch-alignment" : circle_pitch_alignment,
                }
            }
        }
        else if(layer.typeIndex == 1) { // ZONES

            mapboxLayer = {
                type: 'fill-extrusion',
                
                paint: {
                    "fill-extrusion-color": this.getParam(this.getColorStr(params.appearance.background.color)),
                    "fill-extrusion-opacity": this.getParam(params.appearance.background.opacity),
                    "fill-extrusion-height": this.getParam(params.extrudeHeight),
                    "fill-extrusion-base": this.getParam(params.extrudeHeightBase)
                }
            }
        }
        else if(layer.typeIndex == 2) { // LINES
            mapboxLayer = {
                type: 'line',
                
                paint: {
                    "line-gradient": this.getParam(this.getColorStr(params.appearance.stroke.color)),
                    "line-opacity": this.getParam(params.appearance.stroke.opacity),
                    "line-width": this.getParam(params.appearance.stroke.width),
                    "line-gap-width": this.getParam(params.appearance.stroke.gapWidth),
                    "line-blur": this.getParam(params.appearance.stroke.blur),
                }
            }
        }
        else if(layer.typeIndex == 3) { // HEATMAP
            mapboxLayer = {
                type: 'heatmap',
                
                paint: {
                    "heatmap-color": this.getParam(this.getColorStr(params.appearance.color)),
                    "heatmap-opacity": this.getParam(params.appearance.opacity),
                    "heatmap-radius": this.getParam(params.radius),
                    "heatmap-weight": this.getParam(params.weight),
                    "heatmap-intensity": this.getParam(params.intensity)
                }
            }
        }

        return mapboxLayer;

    }

    getParam(param){
        if(param.expression != undefined) {
            return eval(param.expression);
        }
        else if(param.graph != undefined){ //should not happen
            return 10;
        }
        else {
            return param;
        }
    }

    getLayerById(id) {

        return this.layers.find(x => x.id == id)

    }

    applyGraph(result){

        //console.log('apply graph from okammap', result)
        //TODO: match with property

        //this.map.setPaintProperty(this.graph_layer.mapLayerName, 'circle-radius', eval(result));
        this.setLayerParamMapBox(this.graph_layer, this.graph_layer_params, result, true)
    }

    saveGraph(result, graph) {
        //this.okanMap.graph_layer.graphSave = graph;
        graph = JSON.parse(graph)

        console.log('saving graph to layer object', graph);

        /*
        var layer = this.getLayerById(this.graph_layer.id);

        //var params = this.getLayerParams(layer)

        var prev = layer.layerTypeParams[layer.typeIndex].params

        var attributesToChange = ''
        this.graph_layer_params.forEach((attrb) => {
            
            attributesToChange += "['"+attrb+"']";

        })

        eval('layer.layerTypeParams[layer.typeIndex].params'+attributesToChange + ' = { expression: result, graph: graph}');
        */
        //console.log('saving in layer', )
        this.setLayerParam(this.graph_layer, this.graph_layer_params, { expression: result, graph: graph}, true )
        

        console.log('The layers have been updated', this.layers)

    }


    saveColor(color){
        this.addColorToUsedColors(color);
        this.getUsedColor();
        if(!this.colorBlueprintMode) {
            console.log('Saving color', color)
            this.applyColor(color);
            this.showColorPicker = false;
            
            console.log(color)
            this.setLayerParam(this.colorLayerApply, this.colorLayersParamsApply, {r: color.rgb.r, g: color.rgb.g, b: color.rgb.b, a: color.rgb.a} )
        }
        else {
            this.showColorPicker = false;
        }
        

    }

    applyColor(color) {

        if(!this.colorBlueprintMode)
            this.setLayerParamMapBox(this.colorLayerApply, this.colorLayersParamsApply, "'" + color.rgbaText + "'")
        else {
            //console.log(this.colorPicker)
            this.graphComponent.graph['_nodes'].find(n => n.id == this.colorNodeId).properties['red'] = color.rgb.r
            this.graphComponent.graph['_nodes'].find(n => n.id == this.colorNodeId).properties['green'] = color.rgb.g
            this.graphComponent.graph['_nodes'].find(n => n.id == this.colorNodeId).properties['blue'] = color.rgb.b
            this.graphComponent.graph['_nodes'].find(n => n.id == this.colorNodeId).properties['alpha'] = color.rgb.a

            this.graphComponent.graph['_nodes'].find(n => n.id == this.colorNodeId).colorPickerR.value = color.rgb.r
            this.graphComponent.graph['_nodes'].find(n => n.id == this.colorNodeId).colorPickerG.value = color.rgb.g
            this.graphComponent.graph['_nodes'].find(n => n.id == this.colorNodeId).colorPickerB.value = color.rgb.b
            this.graphComponent.graph['_nodes'].find(n => n.id == this.colorNodeId).colorPickerA.value = color.rgb.a

            this.graphComponent.graph['_nodes'].find(n => n.id == this.colorNodeId).colorChosen = {
                r : color.rgb.r,
                g: color.rgb.g,
                b: color.rgb.b,
                a: color.rgb.a
            }
            this.graphComponent.graph.change();
        }
        
    }

    addColorToUsedColors(color){
        if(!this.usedColors.includes(color.hex)) {
            this.usedColors.push(color.hex)
        }
    }

    getUsedColor(){
        //TODO : get used colors in map
        //this.usedColors = ['#AE8CA3', '#817F82', '#A2ABB5', '#95D9DA']
    }

    setLayerParam(layer, params, value, fromBlueprint = false, graph = null) {

        var paramsLayer = ""
        params.forEach( (attr) => {
            paramsLayer += "['"+attr+"']";
        });

        
        var commandSet = 'this.layers.find(x => x.id == layer.id).layerTypeParams[layer.typeIndex].params' + paramsLayer + ' = value;'
        console.log(commandSet)
        console.log(value)

        // dirty execute saving command
        try {
            eval(commandSet);
            console.log(this.layers)
        }
        catch(e) {
            console.log(e)
        }
    }

    setLayerParamMapBox(layer, params, value, fromBlueprint = false) {

        if(this.map != undefined && this.map != null) {

            var paramsLayer = ""

            params.forEach( (attr) => {
                paramsLayer += "['"+attr+"']";
            });

            //console.log(paramsLayer)
            var mapboxPars = eval('layer.layerTypeParamsMapbox[layer.typeIndex].params' + paramsLayer)
            //console.log(mapboxPars)

            var multipleLayers = false;
            
            var layerMapBoxAttribute = 'mapLayerName'
            if(layer.typeIndex == 0){
                if(mapboxPars.layer == 'cluster')
                    layerMapBoxAttribute = 'mapClusterLayerName';
                else if (mapboxPars.layer == 'cluster_text')
                    layerMapBoxAttribute = 'mapClusterTextLayerName';
                else if (mapboxPars.layer == 'all') {
                    layerMapBoxAttribute = ['mapLayerName', 'mapClusterLayerName', 'mapClusterTextLayerName']
                    multipleLayers = true;
                }
                    
            }
            else if (layer.typeIndex == 1) {
                if(mapboxPars.layer == 'contour')
                    layerMapBoxAttribute = 'mapContourLayerName'
            }
            

            var commandMapBox = "this.map." + mapboxPars.fc + "(" + "layer." + layerMapBoxAttribute + ", '" + mapboxPars.name + "' , " + value  + ")"

            if(fromBlueprint)
                commandMapBox = "this.map." + mapboxPars.fc + "(" + "layer." + layerMapBoxAttribute + ", '" + mapboxPars.name + "' , eval(value))"

            if(multipleLayers) {
                commandMapBox = "this.map." + mapboxPars.fc + "(" + "layer." + layerMapBoxAttribute[0] + ", '" + mapboxPars.name + "' , " + value  + ")"
            }
            ////this.map.setPaintProperty(this.graph_layer.mapLayerName, 'circle-radius', );

            //console.log(commandMapBox)

            // dirty execute mapbox
            try {
                //eval(commandMapBox);

                if(!multipleLayers) {
                    eval(commandMapBox);
                    
                }
                else {
                    var context = this;
                    layerMapBoxAttribute.forEach( (mpatr) => {
                        if(layer[mpatr] != '') {
                            commandMapBox = "context.map." + mapboxPars.fc + "(" + "layer." + mpatr + ", '" + mapboxPars.name + "' , " + value  + ")"
                            eval(commandMapBox);
                        }
                    })
                    
                }
            }
            catch(e) {
                console.log(e)
            }
            
        }
       
    }



}